import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, Inject, PLATFORM_ID, ViewChild, Input, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params, ParamMap } from '@angular/router';
import { DistributorService } from '../distributors/distributors.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { Distributor } from './distributor.model';
import { environment } from '../../environments/environment';
import { voivodeship } from './distributor.model';
import { Settings } from '../shared/navigation/pages.model';
import { Subscription, Observable, BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { MAP_LOADED } from '../shared/shared.module';
import { ViewportScroller, isPlatformBrowser } from '@angular/common';
import SwiperCore, { Navigation, Thumbs, SwiperOptions } from "swiper";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from '../shared/services/utils.service';
import { Product, Products } from '../offer/offer.model';
import { OfferService } from '../offer/offer.service';
SwiperCore.use([Navigation, Thumbs]);

@Component({
  selector: 'app-distributor',
  templateUrl: 'distributor.component.html',
  styleUrls: ['distributor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class DistributorComponent implements OnInit {

  public isBrowser = false;
  public slug: string;
  public page: any;
  public distributor: BehaviorSubject<Distributor> = new BehaviorSubject(new Distributor());
  public sub: Subscription = null;
  public cdn = environment.cdn;
  public settings: Settings = new Settings;
  public voivodeship = voivodeship;
  public zoom = 14;
  public center = { lat: 52.240371, lng: 19.699272 };
  public options = {};
  public infoContent = '';
  public thumbsSwiper: any;
  public config: SwiperOptions = {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: true,
      rewind: true,
      centeredSlides: true,
      centerInsufficientSlides: true
  };
  public subjects = [
    {value: 1, viewValue: $localize `:@@cntct_sub_1:Zakup przyczepy`},
    {value: 2, viewValue: $localize `:@@cntct_sub_2:Zakup części zamiennych`},
    {value: 3, viewValue: $localize `:@@cntct_sub_3:Prośba o dokumenty do przyczepy`},
    {value: 4, viewValue: $localize `:@@cntct_sub_4:Chcę zostać dealerem`},
    {value: 5, viewValue: $localize `:@@cntct_sub_5:Inne`}
  ]
  public loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public sent: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public res: BehaviorSubject<number> = new BehaviorSubject(0);
  public form: FormGroup;


  public products_featured: BehaviorSubject<Products>;

  @ViewChild(MapInfoWindow, { static: false }) info: MapInfoWindow;
  @ViewChild('mapwrap', { static: false }) map: ElementRef;

  constructor(@Inject(PLATFORM_ID) private platformId: string, @Inject(MAP_LOADED) public mapLoaded$: Observable<boolean>, private router: Router, private route: ActivatedRoute, private distributorsService: DistributorService,
  private fb: FormBuilder, private navigationService: NavigationService, private utilsService: UtilsService, public offerService: OfferService, public scroller: ViewportScroller) {

      this.route.paramMap.subscribe((params: ParamMap) => {
        this.fetchDistributor(params.get('path'));
      });

     

      if (isPlatformBrowser(this.platformId)) { 
        this.isBrowser = true;
      }


      const tempProduct = new Product();
      tempProduct.id = -1;
      this.products_featured = new BehaviorSubject({pages: {itemCountPerPage: 0}, items: Array(4).fill(tempProduct)});
  }

  ngOnInit() {
    this.page = this.route.snapshot.data;
  }

  fetchDistributor(path: string) {
    this.distributorsService.item(path).pipe(take(1)).subscribe(distributor => {
      this.distributor.next(distributor);
      this.center = { lat: +distributor.horizontalalign, lng: +distributor.verticalalign };
      this.navigationService.setMeta(
        (distributor.meta_title ? distributor.meta_title : distributor.title),
        (distributor.meta_keywords ? distributor.meta_keywords : distributor.title),
        (distributor.meta_description ? distributor.meta_description : distributor.title),
        environment.base + '/dealer/' + distributor.path
      );
      this.createForm();
    }, error => {
      if (error.status === 404) {
        this.router.navigate(['404']);
      }
    });
  }

  createForm() {

    this.form = this.fb.group({
      namesurname: [''], //honeypot
      id_distributor: [this.distributor.value.id, Validators.required],
      subject: ['', Validators.required],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required]],
      message: [''],
      rodo: ['', Validators.requiredTrue],
      newsletter: [''],

      form_name: ['Formularz kontaktowy dystrybutora'],
      click: [this.navigationService.getClickId().value?.click]
    });

    if (this.isBrowser) {
      this.route.fragment.pipe(take(1)).subscribe(fragment => {
        if (fragment == 'contact') {
          setTimeout(() => {
            this.scroller.setOffset([0,70]);
            this.scroller.scrollToAnchor('contactheader');
          }, 100);
        }
      });
    }
  }

  submit() {
    if (this.form.status === 'VALID') {
      this.loading.next(true);
      const formModel = this.form.value;
      this.distributorsService.contact(formModel).pipe(take(1)).subscribe((result: any) => {
        this.loading.next(false);
        if (result.status === 'success'){
          this.sent.next(true);
          this.res.next(1);
          this.utilsService.gtmCustom('dealer_success', {error: 'Form dealer success'});
        } else {
          this.sent.next(false);
          this.res.next(2);
          this.utilsService.gtmCustom('dealer_error', {error: 'Form dealer error'});
        }
      }, error => {
        this.sent.next(false);
        this.res.next(2);
        this.loading.next(false);
        this.utilsService.gtmCustom('dealer_error', {error: 'Form dealer error'});
      }
      );
    } else {
      // if (!this.form.controls.rodo.valid) {
        this.form.controls.rodo.markAsDirty();
      // }
    }
  }

  fetchFeatured() {
    this.offerService.items({ limit: 16, rand: true, day: true }).pipe(take(1)).subscribe(result => {
      this.products_featured.next(result);
    });
  }

  triggerEvent($event, action: string) {
    $event.preventDefault();
    this.utilsService.gtmCustom(action, {page_location: 'distributor'});
  }


}
